exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#foot[data-v-438ebd1e]{position:absolute;bottom:0;left:0;right:0;line-height:30px;background:#f2f2f2;font-size:14px;padding:20px 0;color:#666}#foot .foot_con[data-v-438ebd1e]{width:1000px;margin:0 auto;text-align:center;overflow:hidden}#foot .foot_con .wrap[data-v-438ebd1e]{float:left;width:300px}#foot .foot_con .wrap .list[data-v-438ebd1e]{overflow:hidden}#foot .foot_con .wrap .list p[data-v-438ebd1e],#foot .foot_con .wrap .list span[data-v-438ebd1e]{float:left}#foot .foot_con .wrap1[data-v-438ebd1e]{width:400px}#foot .foot_con .wrap1 .list p[data-v-438ebd1e]{text-align:left;width:300px}#foot .foot_con .wrap3[data-v-438ebd1e]{width:200px;float:right}#foot .public[data-v-438ebd1e]{text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-438ebd1e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/iview-loader??ref--0-1!./src/components/Home/HomeFoot.vue
// module id = jPcx
// module chunks = 12